import styled from 'styled-components'

const LogoImage = styled.div`
  height: 1.375rem;
  cursor: pointer;
`

export default function HeaderLogo() {
  return (
    <LogoImage>
      <svg
        width="80"
        height="22"
        viewBox="0 0 80 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1197_1586)">
          <path
            d="M0 10.9999C0 4.59126 4.57331 0.0478516 11.1971 0.0478516C12.5422 0.0478516 13.7498 0.239153 15.1069 0.801101C15.2324 0.854904 15.3221 0.980445 15.3221 1.11794V7.23361C15.3221 7.52056 14.9933 7.67001 14.7721 7.49067C13.7678 6.67166 12.6678 6.26515 11.4423 6.2771C9.1287 6.28906 7.09611 8.0287 6.84503 10.3303C6.51623 13.3134 8.59664 15.609 11.508 15.609C12.7276 15.609 13.8455 15.1965 14.7721 14.4253C14.9933 14.24 15.3281 14.3895 15.3281 14.6764V20.8818C15.3281 21.0193 15.2384 21.1508 15.1129 21.1986C13.7319 21.7606 12.5482 21.9519 11.2031 21.9519C4.58527 21.9519 0.00597491 17.4085 0.00597491 10.9999H0Z"
            fill="black"
          />
          <path
            d="M16.7637 10.9999C16.7637 4.68093 21.5462 0.0478516 28.0505 0.0478516C34.5548 0.0478516 39.3373 4.68093 39.3373 10.9999C39.3373 17.3188 34.5548 21.9519 28.0505 21.9519C21.5462 21.9519 16.7637 17.3188 16.7637 10.9999ZM32.5341 10.9999C32.5341 8.32164 30.639 6.33688 28.0505 6.33688C25.4619 6.33688 23.5669 8.32164 23.5669 10.9999C23.5669 13.6781 25.4619 15.6628 28.0505 15.6628C30.639 15.6628 32.5341 13.6781 32.5341 10.9999Z"
            fill="black"
          />
          <path
            d="M40.6641 10.9999C40.6641 4.59126 45.2374 0.0478516 51.8612 0.0478516C53.2063 0.0478516 54.4139 0.239153 55.771 0.801101C55.8965 0.854904 55.9862 0.980445 55.9862 1.11794V7.23361C55.9862 7.52056 55.6574 7.67001 55.4362 7.49067C54.4318 6.67166 53.3318 6.26515 52.1063 6.2771C49.7928 6.28906 47.7602 8.0287 47.5091 10.3303C47.1803 13.3134 49.2607 15.609 52.1721 15.609C53.3916 15.609 54.5096 15.1965 55.4362 14.4253C55.6574 14.24 55.9921 14.3895 55.9921 14.6764V20.8818C55.9921 21.0193 55.9025 21.1508 55.7769 21.1986C54.396 21.7606 53.2123 21.9519 51.8672 21.9519C45.2493 21.9519 40.67 17.4085 40.67 10.9999H40.6641Z"
            fill="black"
          />
          <path
            d="M57.4268 10.9999C57.4268 4.68093 62.2093 0.0478516 68.7136 0.0478516C75.2179 0.0478516 80.0004 4.68093 80.0004 10.9999C80.0004 17.3188 75.2179 21.9519 68.7136 21.9519C62.2093 21.9519 57.4268 17.3188 57.4268 10.9999ZM73.1972 10.9999C73.1972 8.32164 71.3021 6.33688 68.7136 6.33688C66.125 6.33688 64.2299 8.32164 64.2299 10.9999C64.2299 13.6781 66.125 15.6628 68.7136 15.6628C71.3021 15.6628 73.1972 13.6781 73.1972 10.9999Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_1197_1586">
            <rect width="80" height="22" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </LogoImage>
  )
}
